import React,{useState,useEffect} from 'react'
import {useParams} from 'react-router-dom'
// import { useFetch } from '../../hooks/useFetch'
import RecipeDetails from './RecipeDetails';

import './Recipe.css'
import useTheme from '../../hooks/useTheme';
import { projFirestore } from '../../firebase/config';

function Recipe() {
  const params = useParams();
  const id = params.id;

  const [data, setData] = useState(null)
  const [isPending, setIsPending] = useState(false)
  const [error, setError] = useState(null)

    useEffect(()=>{
      setIsPending(true)
      projFirestore.collection('recipes').doc(id).get().then((snapshot)=>{
        if(!snapshot.exists){
          setIsPending(false)
          setError('Recipe not exists')
        }else{
         setData({id,...snapshot.data()})
         setIsPending(false)
        }
      })
    },[id])

  const {mode} = useTheme()
  return (
    <div className={`recipe ${mode}`}>
    {isPending && <p className='loading'>Loading Data...</p>}
    {error && <p className='error'>{error}</p>}
    {data && <RecipeDetails recipe={data}/>}
    </div>
  )
}

export default Recipe